import { EXTENSION_LANDING_IMAGE } from "../config/images";
import { iconPath } from "winslow-core";
import "./ExtensionLanding.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";

export const ExtensionLanding = () => {
  const storeUser = useSelector(selectUser);

  return (
    <>
      <div className="extension-landing">
        <div className="extension-landing-inside">
          <div className="extension-landing-image">
            <img
              className="extension-landing-image"
              src={iconPath(EXTENSION_LANDING_IMAGE, storeUser)}
              alt="no_image"
            />
          </div>
          <h1>You're Ready!</h1>
          <h2>
            Click the Chrome Extension when you’re doing work on a link and want
            to add or update it in your workspace. Have fun!
          </h2>
        </div>
      </div>
    </>
  );
};
